<template>
  <div class="columns">
    <div class="column">
      <window title="Longpress button <a href='https://github.com/javisperez/vuelongpress' target='_blank'>(more info)">
        <transition-group name="user" class="users" tag="div">
          <div class="card" v-for="(name, index) in names" :key="name">
            <p>{{ name }}</p>
            <longpress class="button is-primary" :value="index"
            duration="5" :on-confirm="doDelete" pressing-text="Deleting in {$rcounter}"
            action-text="Deleting now, please wait....">
              Delete this user
            </longpress>
          </div>
        </transition-group>
      </window>
    </div>
  </div>
</template>

<script>
import Longpress from 'vue-longpress';

export default {
  data() {
    return {
      names: ['Stanislav Amalric', 'Melanthios Linas', 'Lubomír Francis', 'Eric Irma', 'Aminah Gaëlle', 'Carrie Hersh', 'Darko Clemens'],
    };
  },
  components: { Longpress },
  methods: {
    doDelete(index) {
      this.names.splice(index, 1);
      // console.log('That is, it\'s gone!')
    },
  },
};
</script>

<style scoped>
.card {
  box-shadow: 1px 1px 10px #b1b1b1;
  margin: 10px;
  padding: 20px;
  display: inline-block;
  width: 250px;
  font-size: 18px;
  text-align: center;
  transition: all 1s;
  border-radius: 4px;
  transform-origin: 0 50%;
}
.user-enter,
.user-leave-to {
  opacity: 0;
  transform: scaleX(0);
}
.user-leave-active {
  position: absolute;
}
</style>
